import { render, staticRenderFns } from "./on-service-articles.vue?vue&type=template&id=c301b01e"
import script from "./on-service-articles.vue?vue&type=script&lang=js"
export * from "./on-service-articles.vue?vue&type=script&lang=js"
import style0 from "./on-service-articles.vue?vue&type=style&index=0&id=c301b01e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports